
import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from 'react-hook-form';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faHome, faPlug, faPlus } from "@fortawesome/free-solid-svg-icons";
import { Badge, Breadcrumb, Button, Card, Form, Table } from '@themesberg/react-bootstrap';
import { confirmDeleteToast, sendError, sendSuccess, status } from "../helpers/Helper";
import { API_URL_ENDPOINT } from "../appsetting";
import CustomPagination from "../components/CustomPagination";
import { useNavigate } from "react-router-dom";
import { Routess } from "../Routes/routes";
import { Avatar } from "@mui/material";
import { useApi } from "../helpers/useApi";
import { Model } from "../components/Model";
import { SelectBox } from "../components/SelectBox";
import { Textbox } from "../components/Textbox";

export const States = () => {
  const callApi = useApi();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  
  
  const methods = useForm();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
    watch,
    setValue,
  } = methods;
  const id = watch("id");

  const [showModel, setShowModel] = useState(false);

  const [dataLoading, setDataLoading] = useState(false);
  const [data, setData] = useState({
    items: [],
    pageNo: 1,
    pageSize: 10,
    totalPage: 0,
    totalRecords: 0,
  });

  useEffect(() => {
    getData();
  }, [])

  useEffect(() => {
    const delay = setTimeout(() => {
        if(isTyping){
          setIsTyping(false);
          getData(1);
        }
    }, 300);

    return () => clearTimeout(delay);
  }, [searchTerm]);


  const handlePageChange = (newPage) => {
    getData(newPage);
  }

  const getData = async (cp = null) => {
    try {
      setDataLoading(true);
      const filters = [];
      if (searchTerm) filters.push(`SearchText:${searchTerm}`)
      const queryParams = [
        filters.length ? `filters=${filters.join(",")}` : null,
        `pageNo=${cp ?? data.pageNo}`,
        `pageSize=${data.pageSize}`,
        `sortOrder=desc`
      ].filter(Boolean).join("&");

      const response = await callApi(API_URL_ENDPOINT.States + `?${queryParams}`);
      if (response.status) {
        setData(response.data);
      }
    } catch {
      setData({
        items: [],
        pageNo: 1,
        pageSize: 10,
        totalPage: 0,
        totalRecords: 0,
      });
    } finally {
      setDataLoading(false);
    }
  }

  const handleView = (id) => {
    // alert("Not Set")
    navigate(Routess.States.path + `/${id}`)
  }

  const handleEdit = (id) => {
    const item = data?.items.find(x => x.id === id);
    const formattedStateCode = item.gstStateCode && item.gstStateCode !=0 ? item.gstStateCode.toString().padStart(2, '0'): "";
    setShowModel(true)
    reset({
      "id": item.id,
      "stateName": item.stateName,
      "stateCode": formattedStateCode
    })
  }

  const handleDelete = () => {
    confirmDeleteToast(() => {
      sendSuccess("Deleted successfully!");
    });
  };

  const submitForm = async (data) => {
    // console.log("data", data)
    try {
      const response = await callApi(
        `${API_URL_ENDPOINT.States}?stateName=${data.stateName}&stateCode=${data.stateCode}&id=${data.id}`,
        {
          method: "POST",
          data: null,
        }
      );
      if (response.status) {
        setShowModel(false);
        reset({
          "id": "",
          "stateName": "",
          "stateCode": ""
        })
        getData();
        sendSuccess(response.message);
      } else {
        throw Error(response.message || "Something Went Wrong");
      }
    } catch (ex) {
      sendError(ex.message);
    }

  }

  return (
    <>
      <Model show={showModel} size={""}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0">{id != 0 ? "Edit State" : "Add State"}</h5>
          <Button
            variant=""
            style={{ width: 30, height: 30, outline: "none" }}
            className="btn-sm rounded-circle"
            onClick={() => setShowModel(false)}
          >
            <FontAwesomeIcon icon={faClose} />
          </Button>
        </div>
        <FormProvider {...methods}>
          <Form onSubmit={handleSubmit(submitForm)}>
            <div className="row">
              <div className="col-md-12">
                <Form.Group className="mb-3">
                  <Textbox
                    name={"id"}
                    Type="hidden"
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                  <Textbox
                    Label="State Name"
                    name={"stateName"}
                    Placeholder="State Name"
                    validationRules={{ required: "State Name is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Textbox
                    Label="State GST Code"
                    name={"stateCode"}
                    Placeholder="State GST Code"
                    validationRules={{ required: "Code is required",
                      pattern: {
                        value: /^[0-9]{2}$/,
                        message: "Must be exactly 2 digits",
                      }, }}
                    register={register}
                    errors={errors}
                    Type="number"
                    watch={watch}
                  />
                </Form.Group>
              </div>
            </div>
            <div className="text-end">
              <Button
                type="Button"
                className="me-2"
                variant="outline-danger"
                onClick={() => setShowModel(false)}
              >
                Close
              </Button>
              <Button
                type="submit"
                disabled={isSubmitting}
                variant="success"
              >
                Save Changes
              </Button>
            </div>
          </Form>
        </FormProvider>
      </Model>


      <div className="justify-content-between d-flex flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
            <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
            {/* <Breadcrumb.Item>NPSP</Breadcrumb.Item> */}
            <Breadcrumb.Item active>States</Breadcrumb.Item>
          </Breadcrumb>
          <div className="d-flex align-items-center justify-content-between">
            <h4 className="mb-0">States</h4>
          </div>
        </div>
        <div className="d-flex align-items-center">
          <Button onClick={() => setShowModel(true)} className="me-2 d-block" variant="primary" style={{ whiteSpace: "nowrap" }}><FontAwesomeIcon icon={faPlus} /> Add New State</Button>
          <Form.Control value={searchTerm}onChange={(e) => { setSearchTerm(e.target.value); setIsTyping(true); }} type="text" className="shadow-none" placeholder={"Search..."} />
        </div>
      </div>

      <Card border="light" className="shadow-sm mb-4">
        <Card.Body className="pb-0">
          {dataLoading ? (
            <div className="text-center my-3">
              <span className="spinner-border text-primary" role="status"></span>
            </div>
          ) : (
            <Table responsive className="table-centered table-nowrap rounded mb-0">
              <thead className="thead-light">
                <tr>
                  <th className="border-0 text-center">#</th>
                  <th className="border-0 text-center">State Name</th>
                  <th className="border-0 text-center">GST State Name</th>
                  <th className="border-0 text-end pe-4">Action</th>
                </tr>
              </thead>
              <tbody>
                {data?.items?.length > 0 ? (
                  data?.items.map((item, index) => (
                    <tr key={index}>
                      <td className="text-center align-middle">
                        {(data.pageNo - 1) * data.pageSize + index + 1}
                      </td>
                      <td className="fw-bold align-middle text-center">{item.stateName || "-"}</td>
                     <td className="fw-bold align-middle text-center">
                        {item.gstStateCode != null && item.gstStateCode != 0 ? item.gstStateCode.toString().padStart(2, '0') : "-"}
                      </td>
                      <td className="text-end align-middle">
                        <Button variant="danger" className="btn-sm me-2" onClick={() => handleEdit(item.id)}>Edit</Button>
                        <Button variant="primary" className="btn-sm" onClick={() => handleView(item.id)}>View Details</Button>
                        {/* <Button onClick={handleDelete} variant="danger" className="btn-sm">Remove</Button> */}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center">No Data Found</td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
          <div className="d-flex justify-content-end">
            <CustomPagination totalPages={data.totalPage} loading={dataLoading} onPageChange={handlePageChange} />
          </div>
        </Card.Body>
      </Card>
    </>
  );
};
